class PathLink {  

  constructor(fromNode, toNode, cost) {
    if(fromNode != toNode){
      this.fromNode = fromNode;
      this.toNode = toNode;

      if (cost < 0)
      {
        var dx = toNode.x - fromNode.x;
        var dy = toNode.y - fromNode.y;
        cost = Math.sqrt(dx * dx + dy * dy);
      }
      this.Cost = cost;
      this.isInPathTree = false;
    }
  }
}
module.exports = PathLink;